import { createRoute, redirect } from '@tanstack/react-router';
import { useAuth0 } from '@auth0/auth0-react';
import { Route as rootRoute } from './__root';
import { cn } from '@/client/lib/utils';
import { Button } from '@/client/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/client/components/ui/card';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: async ({ context }) => {
    // Redirect to dashboard if already authenticated
    if (context.auth.isAuthenticated) {
      throw redirect({
        to: '/dashboard',
      });
    }
  },
  component: IndexComponent,
});

function LoginForm({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  const { loginWithRedirect } = useAuth0();

  return (
    <div className={cn('flex flex-col gap-6', className)} {...props}>
      <Card>
        <CardHeader className="text-center">
          <CardTitle>Admin Portal</CardTitle>
        </CardHeader>
        <CardContent>
          <Button
            variant="outline"
            className="w-full"
            onClick={() => loginWithRedirect()}
          >
            Login
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

function IndexComponent() {
  return (
    <div className="flex min-h-svh w-full items-center justify-center bg-muted shadow-inner p-6 md:p-10">
      <div className="w-full max-w-sm">
        <LoginForm />
      </div>
    </div>
  );
}
